/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Agentstate1Inputs */

const en_entity_agentstate1 = /** @type {(inputs: Entity_Agentstate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent State`)
};

const de_entity_agentstate1 = /** @type {(inputs: Entity_Agentstate1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentenzustand`)
};

/**
* | output |
* | --- |
* | "Agent State" |
*
* @param {Entity_Agentstate1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_agentstate1 = /** @type {((inputs?: Entity_Agentstate1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Agentstate1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_agentstate1(inputs)
	return de_entity_agentstate1(inputs)
});
export { entity_agentstate1 as "entity_agentState" }